import { render, staticRenderFns } from "./_profileCard.vue?vue&type=template&id=a5033360"
import script from "./_profileCard.vue?vue&type=script&lang=js"
export * from "./_profileCard.vue?vue&type=script&lang=js"
import style0 from "./_profileCard.vue?vue&type=style&index=0&id=a5033360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports